import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documents: [],
  isLoading: false,
  isError: false,
  message: '',
  uploadProgress: 0,
};

export const documentSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = '';
      state.uploadProgress = 0;
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
  },
});

export const { reset, setUploadProgress } = documentSlice.actions;
export default documentSlice.reducer;